export default __webpack_public_path__ + "static/media/winner-leaderboard-banner-cn.a5288298.webp";